
    import has from 'lodash/has';
    import { mapState, mapGetters } from 'vuex';
    import HistogramMarketAvg from '@/components/JobView/Histogram/HistogramMarketAvg';
    import HistogramSeekerNoDesiredPay from '@/components/JobView/Histogram/HistogramSeekerNoDesiredPay';
    import HistogramSeekerPointer from '@/components/JobView/Histogram/HistogramSeekerPointer';
    import HistogramMinMax from '@/components/JobView/Histogram/HistogramMinMax';
    import HistogramChart from '@/components/JobView/Histogram/HistogramChart';

    export default {
        name: 'Histogram',

        components: {
            HistogramMarketAvg,
            HistogramSeekerNoDesiredPay,
            HistogramSeekerPointer,
            HistogramMinMax,
            HistogramChart,
        },

        props: {
            showSeeker: {
                type: Boolean,
                default: false,
            },

            predictedValue: {
                type: [Number, String],
                default: '',
            },
        },

        data() {
            return {
                isModalOpen: false,
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            ...mapGetters('job', {
                $_chartType: 'chartType',
            }),

            classList() {
                return [
                    'histogram',
                    this.getSeekerClass,
                    this.getChartTypeClass,
                ];
            },

            getSeekerClass() {
                return this.showSeeker && this.hasSeekerDesiredPay ? 'with-seeker' : '';
            },

            getChartTypeClass() {
                return `is-${this.$_chartType}`;
            },

            hasSeekerDesiredPay() {
                return has(this.$_me, 'minPayBand.value') && this.$_me.minPayBand.value !== '-1.00';
            },
        },

        methods: {
            onDesirePayClick() {
                this.$emit('desirePayClick');
            },

            openModal() {
                this.isModalOpen = true;
            },

            closeModal() {
                this.isModalOpen = false;
            },
        },
    };
